import { t as e } from "../../chunks/cn.CnaYSZq4.js";
import { t } from "../../chunks/dist.Cf4nu8dn.js";
import { useCallback as n, useEffect as r, useState as i } from "react";
import { GripHorizontal as a, GripVertical as o } from "lucide-react";
import { Fragment as s, jsx as c, jsxs as l } from "react/jsx-runtime";
//#region lib/components/CropDialog/DragHandle.tsx
var u = ({ side: u, offset: d, opposite: f, onChange: p, size: m }) => {
	let [h, g] = i(!1), [_, v] = i(0), [y, b] = i(0), x = t("absolute bg-black opacity-50 pointer-events-none", { variants: { side: {
		top: "top-0 h-2 w-full",
		right: "top-0 bottom-0 right-0 w-2",
		bottom: "bottom-0 left-0 w-full h-2",
		left: "top-0 bottom-0 w-2"
	} } }), S = t("absolute flex overflow-visible", { variants: { side: {
		top: "top-0 left-0 w-full justify-center",
		right: "top-0 bottom-0 right-0 items-center",
		bottom: "bottom-0 left-0 right-0 justify-center",
		left: "top-0 bottom-0 items-center"
	} } }), C = t("flex justify-center items-center bg-black opacity-50 hover:opacity-80 cursor-grab active:cursor-grabbing touch-none", { variants: { side: {
		top: "w-10 h-[22px] rounded-b-md",
		right: "w-[22px] h-10 -ml-[22px] rounded-l-lg",
		bottom: "w-10 h-[22px] -mt-[22px] rounded-t-lg",
		left: "w-[22px] h-10 rounded-r-lg"
	} } }), w = 0;
	d > 0 && (w = d * 22 > m ? m - 22 : d * m);
	let T = {};
	u === "top" ? T.marginTop = w : u === "right" ? T.marginLeft = -(w + 22) : u === "bottom" ? T.marginTop = -(w + 22) : T.marginLeft = w;
	let E = ["top", "bottom"].includes(u) ? { height: `${w}px` } : { width: `${w}px` }, D = n((e) => {
		e.preventDefault(), e.stopPropagation(), g(!0), b(d), v(u === "top" || u === "bottom" ? e.clientY : e.clientX);
	}, [d, u]), O = n((e) => {
		if (!h) return;
		let t;
		t = u === "top" || u === "bottom" ? e.clientY - _ : e.clientX - _, (u === "bottom" || u === "right") && (t = -t);
		let n = Math.max(0, Math.min(1, y + t / m));
		p(Math.min(n, 1 - f - 44 / m));
	}, [
		h,
		_,
		y,
		u,
		m,
		p
	]), k = n(() => {
		g(!1);
	}, []), A = n((e) => {
		e.preventDefault(), e.stopPropagation(), g(!0), b(d);
		let t = e.touches[0];
		v(u === "top" || u === "bottom" ? t.clientY : t.clientX);
	}, [d, u]), j = n((e) => {
		if (!h) return;
		e.preventDefault();
		let t = e.touches[0], n;
		n = u === "top" || u === "bottom" ? t.clientY - _ : t.clientX - _, (u === "bottom" || u === "right") && (n = -n);
		let r = Math.max(0, Math.min(1, y + n / m));
		p(Math.min(r, 1 - f - 44 / m));
	}, [
		h,
		_,
		y,
		u,
		m,
		p
	]), M = n(() => {
		g(!1);
	}, []);
	return r(() => {
		if (h) return document.addEventListener("mousemove", O), document.addEventListener("mouseup", k), document.addEventListener("touchmove", j, { passive: !1 }), document.addEventListener("touchend", M), () => {
			document.removeEventListener("mousemove", O), document.removeEventListener("mouseup", k), document.removeEventListener("touchmove", j), document.removeEventListener("touchend", M);
		};
	}, [
		h,
		O,
		k,
		j,
		M
	]), /* @__PURE__ */ l(s, { children: [/* @__PURE__ */ c("div", {
		className: e(x({ side: u })),
		style: E
	}), /* @__PURE__ */ c("div", {
		className: e(S({ side: u })),
		children: /* @__PURE__ */ l("div", {
			className: e(C({ side: u })),
			style: T,
			onMouseDown: D,
			onTouchStart: A,
			children: [
				u === "top" && /* @__PURE__ */ c(a, {
					size: 20,
					className: "text-white -mt-0.5"
				}),
				u === "right" && /* @__PURE__ */ c(o, {
					size: 20,
					className: "text-white ml-0.5"
				}),
				u === "bottom" && /* @__PURE__ */ c(a, {
					size: 20,
					className: "text-white mt-0.5"
				}),
				u === "left" && /* @__PURE__ */ c(o, {
					size: 20,
					className: "text-white -ml-0.5"
				})
			]
		})
	})] });
};
//#endregion
export { u as DragHandle };
